import { TextField } from "@mui/material";
import React, { useRef, useEffect } from "react";
import UploadFileIcon from "@mui/icons-material/UploadFile";

const FileInput = ({ value, onChange, multiple = false, accept, ...props }) => {
  const ref = useRef(null);
  const handleChange = (e) => {
    // if (!e.target?.files?.length) ref.current.value = ''
    onChange(multiple ? Object.values(e.target.files) : e.target.files[0] || "");
    ref.current.value = "";
  };
  useEffect(() => {
    if (!value) ref.current.value = "";
  }, [value]);
  return (
    <React.Fragment>
      <input type="file" accept={accept || "*"} multiple={multiple} hidden ref={ref} onChange={handleChange} />
      <TextField
        InputLabelProps={{ shrink: true }}
        InputProps={{
          endAdornment: (
            <UploadFileIcon
              onClick={(e) => {
                e.stopPropagation();
                ref.current.click();
              }}
              style={{ cursor: "pointer" }}
            />
          ),
        }}
        onClick={(e) => {
          e.stopPropagation();
          ref.current.click();
        }}
        {...props}
        value={multiple && value ? value.map((file) => ` ${file.name}`) : value?.name || ""}
      />
    </React.Fragment>
  );
};
export default FileInput;
